import React from "react";
import { createRoot } from "react-dom/client";
import MunicipalityMapSection, {
  MunicipalityStatistics,
} from "../components/MunicipalityMap/MunicipalityMapSection";

/** Ritar kommunkartan med kommunväljaren på startsidan. Datan renderas av Razor. */
export function initMunicipalityMap(): void {
  const host = document.getElementById("breaks-map");
  if (!host) {
    return;
  }

  let municipalities: MunicipalityStatistics[] = [];
  try {
    municipalities = JSON.parse(host.dataset.municipalities ?? "[]");
  } catch {
    // Kartan visas ändå, bara utan prickar.
  }

  createRoot(host).render(
    React.createElement(MunicipalityMapSection, {
      heading: host.dataset.heading ?? "",
      municipalities,
      totalMunicipalities: Number(host.dataset.totalMunicipalities) || 0,
      breaksThisWeek: Number(host.dataset.breaksThisWeek) || 0,
      statisticsUrl: host.dataset.statisticsUrl ?? "",
    }),
  );
}
